export const getStates = (countryCode, fieldType) => {
  const deliveryCountries = window.start.addresses?.deliveryCountryList || [];
  
  let autoCompleteOptions = {};
  
  if (deliveryCountries.length > 0) {
    autoCompleteOptions = deliveryCountries
      .find(country => country.iso2.toLowerCase() === countryCode.toLowerCase())
      ?.autoCompleteOptions || {};
  }
  
  if (autoCompleteOptions && autoCompleteOptions[fieldType]) {
    return autoCompleteOptions[fieldType].map(fieldValue => fieldValue);
  }
  
  return [];
};
